"use client";

import { useRouter } from "next/navigation";
import { Button } from "@shared/src/components/ui/button";
import { ixToast } from "@shared/src/utils/ixToast";
import { ButtonProps } from "@shared/src/components/ui/button";
import { forwardRef } from "react";
import { POST_AD_PAGE } from "@shared/src/config/page-links";
import { useKycStatus } from "@shared/src/hooks/useKycStatus";
import { useModalStore } from "@shared/src/stores/useModalStore";
import { IS_MAINNET } from "@shared/src/constants";

type CreateAdButtonProps = Omit<ButtonProps, "onClick"> & {
  adType?: "buy" | "sell";
};

export const CreateAdButton = forwardRef<HTMLButtonElement, CreateAdButtonProps>(({ className, adType, ...props }, ref) => {
  const router = useRouter();
  const { kycStatus } = useKycStatus();

  const isVerified = IS_MAINNET ? kycStatus === "approved" : true;

  const handleClick = () => {
    if (isVerified) {
      const url = adType ? `${POST_AD_PAGE}?type=${adType}` : POST_AD_PAGE;
      router.push(url);
    } else {
      ixToast.success("Please complete KYC to post an ad");
      router.push("/user-kyc");
    }
  };

  return (
    <Button ref={ref} variant="primary" size="md" radius="full" onClick={handleClick} className={className} {...props}>
      Post {adType ? "a" : "an"} {adType} ad
    </Button>
  );
});

CreateAdButton.displayName = "CreateAdButton";
